import { render, staticRenderFns } from "./DeveloperSettings.vue?vue&type=template&id=162514e2&scoped=true"
import script from "./DeveloperSettings.vue?vue&type=script&lang=js"
export * from "./DeveloperSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162514e2",
  null
  
)

export default component.exports